<mat-card [style.background-color]="uiData.atp.color">
    <h2 mat-dialog-title>
        <mat-icon>group</mat-icon> Match Student Uploads to Existing Individuals
    </h2>
</mat-card>
<mat-dialog-content class="scroll-container">
    <section *ngIf="loading">
        <h2>Loading...</h2>
        <mat-progress-bar mode="indeterminate" color="warn" aria-label="Loading...">
        </mat-progress-bar>
    </section>
    <mat-card *ngIf="!loading">
        <div>
            <mat-accordion>
                <ng-container *ngFor="let student of data.students; let i = index">
                    <mat-expansion-panel [disabled]="dataSource[i].data.length === 0">
                        <mat-expansion-panel-header [ngStyle]="{ 'background-color': getBackgroundColor(student) }">
                            <mat-panel-title fxLayout="column" fxLayoutAlign="start start" style="width: 100%;">
                                <span><strong>Student:</strong> {{ student.firstName }} {{ student.lastName }}</span>
                                <span *ngIf="student.dateOfBirth"><strong>DOB:</strong> {{ student.dateOfBirth | date:'MM/dd/yyyy' }}</span>
                                <span><strong>Address:</strong> {{ student.streetAddress + ', ' + student.city + ', ' + student.state + ' ' + student.zipCode }}</span>
                            </mat-panel-title>
                            <mat-panel-description *ngIf="dataSource[i].data.length === 0">
                                No possible matches found
                            </mat-panel-description>
                            <mat-panel-description *ngIf="dataSource[i].data.length > 0">
                                <div *ngIf="student.selectedPerson" class="selected-person-container">
                                    <div fxLayout="column">
                                        <span><strong>Selected Match: </strong>{{ student.selectedPerson.id }}: {{ student.selectedPerson.firstName }} {{ student.selectedPerson.middleName }} {{ student.selectedPerson.lastName }}</span>
                                        <span *ngIf="student.selectedPerson.dateOfBirth"> <strong>DOB: </strong>{{ student.selectedPerson.dateOfBirth | date:'MM/dd/yyyy' }} </span>
                                        <span *ngIf="student.selectedPerson.response"> <strong>Address: </strong>{{ student.selectedPerson.response }} </span>
                                    </div>
                                    <div fxLayout="row">
                                        <button mat-icon-button color="primary" (click)="editPerson(student.selectedPerson, $event)">
                                            <mat-icon>remove_red_eye</mat-icon>
                                        </button>
                                        <button mat-icon-button class="clear-button" (click)="clearSelection(i, $event)">
                                            <mat-icon>clear</mat-icon>
                                        </button>
                                        &nbsp;&nbsp;
                                    </div>
                                </div>

                                <div style="flex: 1 1 auto;">                                                                   
                                    <span>possible matches: {{ dataSource[i]?.data.length }}</span>
                                    <div style="flex: 1 1 auto;"></div>                                
                                    <button mat-raised-button color="warn" [disabled]="!student.selectedIndividuals || student.selectedIndividuals.length < 2" (click)="mergeIndividuals(student.selectedIndividuals, i, $event)" [matTooltip]="getMergeTooltip(student.selectedIndividuals)">
                                        <mat-icon>call_merge</mat-icon> Merge Individuals {{student.selectedIndividuals?.length > 0 ? '(' + student.selectedIndividuals.length + ')': ''}}
                                    </button>
                                </div>
                                                                

                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div>
                            <mat-table [dataSource]="dataSource[i]" matSort class="mat-elevation-z8">
                                <!-- Radio Button Column -->
                                <ng-container matColumnDef="select">
                                    <mat-header-cell *matHeaderCellDef fxFlex="5%"></mat-header-cell>
                                    <mat-cell *matCellDef="let element" fxFlex="5%">
                                    <mat-radio-group [(ngModel)]="student.selectedPerson" (change)="updateSelection(element, $event, i)">
                                        <mat-radio-button [value]="element"></mat-radio-button>
                                    </mat-radio-group>
                                    </mat-cell>
                                </ng-container>

                                <!-- Dynamic Columns -->
                                <ng-container *ngFor="let column of columnNames" [matColumnDef]="column">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header [fxFlex]="columnData[column].displaySize + '%'">
                                    {{ columnData[column].displayName }}
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let element" [fxFlex]="columnData[column].displaySize + '%'">                                        
                                        <ng-container [ngSwitch]="columnData[column].displayType">
                                            <span *ngSwitchCase="'date'">{{ element[column] | date:'MM/dd/yyyy' }}</span>
                                            <span *ngSwitchCase="'button'">
                                                <button mat-icon-button color="primary" (click)="editPerson(element, $event)">
                                                    <mat-icon>remove_red_eye</mat-icon>
                                                </button>
                                                <mat-checkbox 
                                                    [checked]="isSelected(element, i)"
                                                    (change)="toggleSelection(element, i)"
                                                    (click)="$event.stopPropagation()">
                                                </mat-checkbox>
                                            </span>
                                            <span *ngSwitchDefault>{{ element[column] }}</span>
                                        </ng-container>                                        
                                    </mat-cell>
                                </ng-container>

                                <!-- Header and Row Declarations -->
                                <mat-header-row *matHeaderRowDef="['select'].concat(columnNames)"></mat-header-row>
                                <mat-row *matRowDef="let row; columns: ['select'].concat(columnNames)"></mat-row>
                            </mat-table>
                        </div>
                    </mat-expansion-panel>
                </ng-container>
            </mat-accordion>
        </div>
    </mat-card>
</mat-dialog-content>
<mat-card [style.background-color]="uiData.atp.color">        
    <div>        
        <button mat-button mat-raised-button (click)="returnResults()">
            Done
        </button>
    </div>
</mat-card>